import { IconArrowLeft, IconSettings } from "@tabler/icons-react";
import { useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  SetBackButtonVisibilityContext,
  TitleContext,
  TitleDescriptionContext,
} from "@common/context/ThemeContext";
import { __ } from "@common/helpers/i18n";
import Logo from "@app/assets/Logo";
import { Button } from "@app/elements/form";

export default function NavBar() {
  const setbackButtonVisibility = useContext(SetBackButtonVisibilityContext);
  const title = useContext(TitleContext);
  const description = useContext(TitleDescriptionContext);

  const history = useHistory();
  const location = useLocation();
  const primaryMobileRoutes = new Set([
    "/dashboard",
    "/automation",
    "/posts",
    "/inbox",
    "/comment",
  ]);
  const showBackButton = !primaryMobileRoutes.has(location.pathname);
  const settingsChildRoutes = [
    "/accounts",
    "/clients",
    "/integrations",
    "/order",
    "/renew",
    "/team",
    "/user",
  ];
  const goBack = () => {
    if (
      settingsChildRoutes.some((route) => location.pathname.startsWith(route))
    ) {
      history.replace("/settings");
      return;
    }

    if (history.length > 1) {
      history.goBack();
      return;
    }

    history.push("/dashboard");
  };

  return (
    <header
      className="sticky top-0 z-navbar flex flex-shrink-0 border-b border-border bg-card/95 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-card/90 md:hidden"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="flex h-[60px] min-w-0 flex-1 items-center gap-2.5 px-3">
        {showBackButton ? (
          <Button
            variant="outline-light"
            padding="none"
            onClick={goBack}
            className="h-9 w-9 flex-shrink-0 rounded-md bg-background text-muted-foreground hover:text-foreground"
            aria-label={__("Back")}
          >
            <IconArrowLeft size={20} stroke={2} className="rtl:rotate-180" />
          </Button>
        ) : (
          <Button
            variant="outline-light"
            padding="none"
            onClick={() => {
              setbackButtonVisibility(false);
              history.push("/dashboard");
            }}
            className="h-9 w-9 flex-shrink-0 rounded-md bg-background text-primary hover:border-primary/25 hover:bg-primary/10"
            aria-label={__("Dashboard")}
          >
            <Logo className="h-6 w-6" />
          </Button>
        )}

        <div className="min-w-0 flex-1 text-start">
          <h1
            id="primary-heading"
            className="truncate text-[15px] font-extrabold leading-6 text-foreground"
          >
            {title}
          </h1>
          {description && (
            <p className="truncate text-mini font-medium leading-5 text-muted-foreground">
              {description}
            </p>
          )}
        </div>

        <Button
          variant="outline-light"
          padding="none"
          className="h-9 w-9 flex-shrink-0 rounded-md bg-background text-muted-foreground hover:text-foreground"
          aria-label={__("Go to settings")}
          onClick={() => {
            setbackButtonVisibility(false);
            history.push("/settings");
          }}
        >
          <IconSettings size={20} stroke={2} />
        </Button>
      </div>
    </header>
  );
}
